import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';
import FlowIcon from '@/comp/common/icons/FlowIcon';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { FlowAndPressureSensorNodeModel } from './FlowAndPressureSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';
import PressureComboIcon from '@/comp/common/icons/PressureComboIcon';

export class FlowAndPressureSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.FlowAndPressureSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new FlowAndPressureSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={83}
        height={44}
        data={[
          {
            metric: MetricType.FlowM3Min,
            unit: UnitsEnum.m3Min,
            Icon: <FlowIcon />,
          },
          {
            metric: MetricType.PressureBar,
            unit: UnitsEnum.bar,
            Icon: <PressureComboIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
